export default __webpack_public_path__ + "static/media/05.f7c5bf88.jpg";